import { Avatar, Title } from "@mantine/core";
import { IconCar } from "@tabler/icons-react";

const InventoryDoneCard = ({ props, onClick }) => {
  const {
    name,
    remarks,
    productList,
    deliveryPerson,
    licensePlateNumber,
    warehouseStaff = "",
    createdAt,
    id,
    documentId,
  } = props || {};

  return (
    <div
      className="mx-4 my-4 flex max-w-md cursor-pointer flex-col rounded-lg bg-white p-6 shadow-lg md:mx-8 md:max-w-2xl"
      onClick={onClick}
    >
      <Title
        className="py-2"
        order={1}
        style={{ textOverflow: "ellipsis", overflow: "hidden" }}
      >
        {name || null}
      </Title>
      <div className="py-2">{id}</div>
      {licensePlateNumber ? (
        <div className="flex items-center gap-2 py-2 text-sm text-gray-600">
          <IconCar size={15} className="text-gray-400" />
          <span className="truncate">{licensePlateNumber}</span>
        </div>
      ) : null}
    </div>
  );
};

export default InventoryDoneCard;
